import React, { useState, useEffect, useCallback } from 'react';
import Rail from './components/latent/Rail';
import Home from './components/latent/Home';
import Projects from './components/latent/Projects';
import Experience from './components/latent/Experience';
import Education from './components/latent/Education';
import Research from './components/latent/Research';
import Blogs from './components/latent/Blogs';
import About from './components/latent/About';
import Drawer from './components/latent/Drawer';
import MimikreeChat from './components/latent/MimikreeChat';
import type { ViewName } from './types';

const VALID: ViewName[] = [
  'now',
  'projects',
  'experience',
  'education',
  'research',
  'blogs',
  'about',
];

function resolveView(raw: string): ViewName {
  if (raw === 'atlas' || raw === 'space' || raw === '') return 'now';
  if (raw === 'work') return 'projects';
  const h = raw as ViewName;
  return VALID.includes(h) ? h : 'now';
}

function App() {
  const [view, setView] = useState<ViewName>(() =>
    resolveView(window.location.hash.replace('#', ''))
  );
  const [drawerId, setDrawerId] = useState<string | null>(null);

  const go = useCallback((name: ViewName) => {
    setView(name);
    window.history.replaceState(null, '', `#${name}`);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const onHash = () => {
      setView(resolveView(window.location.hash.replace('#', '')));
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const openProject = useCallback((id: string) => setDrawerId(id), []);
  const closeDrawer = useCallback(() => setDrawerId(null), []);

  return (
    <>
      <Rail current={view} onGo={go} />
      <main className="shell">
        <section className={`view${view === 'now' ? ' on' : ''}`} id="view-now">
          <Home onGo={go} onOpenProject={openProject} />
        </section>
        <section className={`view${view === 'projects' ? ' on' : ''}`} id="view-projects">
          <Projects onOpen={openProject} />
        </section>
        <section className={`view${view === 'experience' ? ' on' : ''}`} id="view-experience">
          <Experience />
        </section>
        <section className={`view${view === 'education' ? ' on' : ''}`} id="view-education">
          <Education />
        </section>
        <section className={`view${view === 'research' ? ' on' : ''}`} id="view-research">
          <Research />
        </section>
        <section className={`view${view === 'blogs' ? ' on' : ''}`} id="view-blogs">
          <Blogs />
        </section>
        <section className={`view${view === 'about' ? ' on' : ''}`} id="view-about">
          <About />
        </section>
      </main>
      <Drawer projectId={drawerId} onClose={closeDrawer} />
      <MimikreeChat />
    </>
  );
}

export default App;
